function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable arrow-body-style */
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import Modal from '@mui/material/Modal';
import { Close as CloseIcon } from '@mui/icons-material';
import { colors } from '../../theme/index.js';
import Button from '../Button.js';
import Text from '../Text.js';
import ModalContent from '../ModalContent.js';
import ModalFilePreview from '../ModalFilePreview.js';
import pdfImage from '../../../src/assets/pdf.png';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class DropZoneModal extends Component {
  state = {
    showContactModal: false,
    files: [],
    fileName: '',
    showDropzone: true,
    thumbnails: []
  };
  _chooseDocument = async files => {
    if (files[1] !== null) {
      files = new Array(files[0]);
    }
    const duplicate = this.state.files.some(file => file.name === files[0].name);
    const file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!duplicate) {
        // Set thumbnail image to pdf.png if they type is pdf
        let thumbnailImage = reader.result;
        if (file.type === 'application/pdf') {
          thumbnailImage = pdfImage;
        }
        this.setState({
          fileName: files[0].name,
          files: [...this.state.files, ...files],
          thumbnails: [...this.state.thumbnails, {
            name: files[0].name,
            image: thumbnailImage
          }]
        });
      } else {
        // this.props.dispatch(notifier.displayError({ verbiage: 'File already selected, please select a different file.' }));
        alert('File already selected, please select a different file.');
      }
    };
    await this.setState({
      showDropzone: this.state.files.length < this.props.maxItems
    });
  };
  _fileName = file => {
    let filename = null;
    file.name.length > 25 ? filename = `${file.name.substr(0, 11)}...${file.name.substr(-11)}` : filename = file.name;
    return filename;
  };
  _removeDocument = async name => {
    const fileArray = this.state.files.filter(file => file.name !== name);
    const thumbnailArray = this.state.thumbnails.filter(thumb => thumb.name !== name);
    await this.setState({
      files: fileArray,
      thumbnails: thumbnailArray,
      showDropzone: true
    });
  };
  _submitDocument = async () => {
    if (this.state.files.length > 0) {
      const submit = await this.props.collectFiles(this.state.files, this.state.thumbnails);
      this.props.hideModal();
      return submit;
    }
    return null;
  };
  render() {
    const {
      classes,
      showModal,
      hideModal,
      title,
      acceptedFiles,
      id,
      testid
    } = this.props;
    const {
      showDropzone
    } = this.state;
    const styles = {
      btn: {
        width: 'fit-content',
        marginLeft: 'auto'
      },
      closeModalIcon: {
        cursor: 'pointer',
        display: 'inline',
        marginTop: '5px',
        fontSize: '22px',
        float: 'right',
        color: colors.mainTextGrey
      },
      titleIconWrapper: {
        display: 'block',
        width: '100%',
        paddingBottom: '15px',
        verticalAlign: 'center'
      },
      cardStyle: {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${colors.mediumBlue}`,
        borderRadius: '8px',
        textAlign: 'center',
        color: colors.mediumBlue
      },
      cardDisabled: {
        backgroundColor: colors.lightGrey,
        boxShadow: 'none',
        padding: '20px',
        border: `2px dotted ${colors.mediumLightGrey}`,
        borderRadius: '8px',
        color: colors.mediumLightGrey
      },
      previewWrapper: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginBottom: '10px',
        backgroundColor: colors.lightGrey,
        boxShadow: 'none',
        padding: '5px',
        borderRadius: '8px'
      },
      fileTitle: {
        maxWidth: '300px',
        wordBreak: 'break-all'
      },
      thumbnail: {
        maxWidth: 260,
        paddingBottom: 25,
        paddingTop: 35
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      open: showModal,
      onClose: hideModal,
      style: {
        overflow: 'auto',
        'WebkitOverflowScrolling': 'touch'
      },
      disableEscapeKeyDown: true,
      disableEnforceFocus: true
    }, /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement("div", {
      style: styles.titleIconWrapper
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: styles.closeModalIcon,
      onClick: hideModal
    }), /*#__PURE__*/React.createElement(Text, {
      align: "center",
      bold: true,
      mediumLarge: true,
      display: "inline-block",
      margin: "0"
    }, title)), this.state.files.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.previewWrapper
    }, this.state.files.map(file => {
      const fileName = this._fileName(file);
      return /*#__PURE__*/React.createElement(ModalFilePreview, {
        key: fileName
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        style: styles.closeModalIcon,
        onClick: () => this._removeDocument(file.name)
      }), this.state.thumbnails.map(thumb => {
        if (file.name === thumb.name) {
          return /*#__PURE__*/React.createElement("img", {
            key: thumb,
            alt: "Thumbnails",
            src: thumb.image,
            style: styles.thumbnail
          });
        }
        return null;
      }), /*#__PURE__*/React.createElement(Text, {
        align: "center",
        bold: true,
        mediumLarge: true,
        display: "block",
        margin: "0",
        customStyle: {
          maxWidth: '300px',
          width: '100%'
        }
      }, fileName));
    }))), this.state.showDropzone && /*#__PURE__*/React.createElement(Dropzone, {
      onDrop: files => this._chooseDocument(files),
      accept: acceptedFiles || "image/jpeg, image/jpg, image/png, video/mp4"
    }, ({
      getRootProps,
      getInputProps
    }) => /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
      style: !showDropzone ? styles.cardDisabled : styles.cardStyle
    }), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Text, {
      id: id || testid,
      color: "skyBlue",
      margin: "20px 0",
      small: true,
      align: "center"
    }, i18n.t(tokens.labels.employees.dragAndDropImagesHere))))), acceptedFiles && /*#__PURE__*/React.createElement(Text, {
      margin: "10px 0 0",
      align: "center",
      tiny: true
    }, acceptedFiles), /*#__PURE__*/React.createElement(Button, {
      disabled: this.state.files.length === 0,
      onClick: this._submitDocument,
      color: "primary",
      customStyle: styles.btn,
      marginTop: 5
    }, "Submit")));
  }
}
export default DropZoneModal;